import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Drawer, Box, Grid, Typography, IconButton, Divider } from '@material-ui/core'
import { useParams } from '@reach/router'

import RejectIcon from '_assets/icons/ic-reject.svg'
import CloseIcon from '_assets/icons/ic-close.svg'
import Svg from '_components/svg'

import useStyles from './styles'
import RejectBudgetForm from './components/RejectBudgetForm'

const RejectBudgetDrawer = ({
  className,
  isOpen,
  onClose,
  isRevised,
  setSavingBudget,
  isSavingLoading,
}) => {
  const styles = useStyles()
  const { serviceOrderId, budgetId } = useParams()

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      className={classnames(styles.container, className)}
    >
      <Box className={styles.box}>
        <Grid component="header" className={styles.header}>
          <Svg icon={RejectIcon} className={styles.rejectIcon} />
          <Typography className={styles.title} typography="h4" component="h1">
            Recusar orçamento ID #{budgetId}
          </Typography>
          <IconButton onClick={onClose} aria-label="Fechar menu">
            <Svg icon={CloseIcon} className={styles.close} />
          </IconButton>
        </Grid>
        <Divider className={styles.divider} />

        <div className={styles.content}>
          <RejectBudgetForm
            onClose={onClose}
            isRevised={isRevised}
            setSavingBudget={setSavingBudget}
            isSavingLoading={isSavingLoading}
            styles={styles}
            serviceOrderId={serviceOrderId}
            budgetId={budgetId}
          />
        </div>
      </Box>
    </Drawer>
  )
}

RejectBudgetDrawer.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  isRevised: PropTypes.bool,
  setSavingBudget: PropTypes.func.isRequired,
  isSavingLoading: PropTypes.bool,
}

RejectBudgetDrawer.defaultProps = {
  className: '',
  isOpen: true,
  isRevised: false,
  isSavingLoading: false,
}

export default React.memo(RejectBudgetDrawer)
